import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { Collapse, Divider, List, ListItemButton, ListItemSecondaryAction, ListItemText } from '@mui/material'
import React, { useState } from 'react'
import SubRubro from './SubRubro'

export const DrawertItems = (params) => {
    const { setCategorias, setDrawerOpen, categorias, label } = params
    const [collapseOpen, setCollapseOpen] = useState(false)

    return <>
        <List component="div" disablePadding>
            <ListItemButton onClick={() => { setDrawerOpen(false); setCategorias(label === "Todos los productos" ? "" : label) }} >
                <ListItemText primary={label} />
            </ListItemButton>
            {categorias[label] && <ListItemSecondaryAction>
                <ListItemButton onClick={() => setCollapseOpen(!collapseOpen)}>
                    {collapseOpen ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
            </ListItemSecondaryAction>}
        </List >
        <Divider />
        <Collapse in={collapseOpen} timeout="auto" unmountOnExit>
            {categorias[label] && Object.keys(categorias[label]).map((categoria, i) => {
                return (
                    <div key={`${categoria}-${i}`}>
                        <SubRubro rubro={categoria} categorias={categorias} label={label} setCategorias={setCategorias} setDrawerOpen={setDrawerOpen} />
                    </div>
                )
            })}
        </Collapse>
    </>
}

